import React, { useEffect, useState } from 'react';
import { Layout } from 'blaze-validator';
import PropTypes from 'prop-types';
import { useLocalStorage } from '../../util/hooks';
import Form from '../form/Form';
import { modal } from '../modal/ModalEmitter';
import { addCssClass, removeCssClass } from '../../util/general';

const layout = [
  {
    col: 6,
    name: 'enable',
    label: 'Enable Persistant Sidebar',
    control: 'checkbox',
  },
  {
    col: 6,
    name: 'theme',
    label: 'Theme',
    noEmptyOption: true,
    options: [
      { label: 'Light', value: 'light' },
      { label: 'Dark', value: 'dark' },
    ],
  },
];

const layoutInstance = new Layout(layout);

const SidebarSettings = ({ toggleSideBar }) => {
  const [showSideBar] = useLocalStorage('showSideBar', true);
  const [showMiniMenu, setShowMiniMenu] = useLocalStorage('showMiniMenu', true); // eslint-disable-line
  const [sideBarTheme, setSideBarTheme] = useLocalStorage('sideBarTheme', 'dark');
  const [loading, setLoading] = useState(true);

  const onSubmit = payload => {
    const newSideBarValue = payload.enable === 'Y';
    toggleSideBar(newSideBarValue);
    setSideBarTheme(payload.theme);

    const updateTheme = payload.theme !== sideBarTheme;
    const updateSideBar = newSideBarValue !== showSideBar;

    const element = document.getElementById('side-bar');
    if (element) {
      if (updateTheme) {
        if (payload.theme === 'dark') {
          addCssClass(element, 'dark');
        } else {
          removeCssClass(element, 'dark');
        }
      }

      if (updateSideBar) {
        if (payload.enable !== 'Y') {
          addCssClass(element, 'disabled');
        } else {
          removeCssClass(element, 'disabled');
          removeCssClass(element, 'open');
          addCssClass(element, 'mini');
          setShowMiniMenu(true);
        }
      }

      if (updateSideBar) {
        setTimeout(() => {
          window.dispatchEvent(new Event('resize'));
          if (window.calendar) {
            window.calendar.updateView();
          }
        }, 500);
      }
    }

    modal.close();
  };

  useEffect(() => {
    layoutInstance.populateLayout({ enable: showSideBar ? 'Y' : 'N', theme: sideBarTheme });
    setLoading(false);
  }, []);

  return (
    <div className="side-bar-settings">
      {!loading && (
        <Form
          exportFormat="object"
          layout={layoutInstance.getLayout()}
          onCancel={() => modal.close()}
          submit={onSubmit}
          submitAll
          useDirtyWarning={false}
        />
      )}
    </div>
  );
};

SidebarSettings.propTypes = {
  // using the localstorage setter will not magically update any components using the getter
  toggleSideBar: PropTypes.func,
};

export default SidebarSettings;
